import { takeEvery, call, put, all, fork, select, spawn } from 'redux-saga/effects';

import { companyActions } from './actions';
import { getCompany } from './selectors';
import { companyService } from '../../services/company';

import { onError } from '../../utils/onError';
import { openNotification } from '../../utils/openNotification';
import { downloadBlob } from '../../utils/downloadBlob';

import { history } from '../../settings/history';
import { notificationType } from '../../constants/notification';

function* loadCompanyListWatcher() {
  yield takeEvery(companyActions.LOAD_COMPANY_LIST, function* () {
    try {
      const response = yield call(companyService.loadCompanyList);
      yield put(companyActions.loadCompanyListSuccess(response));
    } catch (e) {
      yield put(companyActions.loadCompanyListFail(e));
      yield spawn(onError, e);
    }
  });
}

function* loadMyCompanyListWatcher() {
  yield takeEvery(companyActions.LOAD_MY_COMPANY_LIST, function* () {
    try {
      const response = yield call(companyService.loadMyCompanyList);
      yield put(companyActions.loadMyCompanyListSuccess(response));
    } catch (e) {
      yield put(companyActions.loadMyCompanyListFail(e));
      yield spawn(onError, e);
    }
  });
}

function* loadCompanyWatcher() {
  yield takeEvery(companyActions.LOAD_COMPANY, function* ({ payload }) {
    const { companyId } = payload;
    try {
      const response = yield call(companyService.loadCompany, companyId);
      yield put(companyActions.loadCompanySuccess(response.data));
    } catch (e) {
      yield put(companyActions.loadCompanyFail(e));
      yield spawn(onError, e);
    }
  });
}

function* loadCompanyAnalyticsWatcher() {
  yield takeEvery(companyActions.LOAD_COMPANY_ANALYTICS, function* ({ payload }) {
    const { companyId } = payload;
    try {
      const response = yield call(companyService.loadCompanyAnalytics, companyId);
      yield put(companyActions.loadCompanyAnalyticsSuccess(response.data));
    } catch (e) {
      yield put(companyActions.loadCompanyAnalyticsFail(e));
      yield spawn(onError, e);
    }
  });
}

function* updateCompanyWatcher() {
  yield takeEvery(companyActions.UPDATE_COMPANY, function* ({ payload }) {
    const { companyId, company } = payload;
    const { is_enabled } = company;
    try {
      const companyBefore = yield select(getCompany);

      if (companyBefore.is_enabled !== is_enabled) {
        is_enabled ? yield call(companyService.enableCompany, companyId) : yield call(companyService.disableCompany, companyId);
      }
      yield call(companyService.updateCompany, companyId, company);
      yield put(companyActions.updateCompanySuccess());
      yield spawn(openNotification, notificationType.success, 'global.editRecordSuccess');
    } catch (e) {
      yield put(companyActions.updateCompanyFail(e));
      yield spawn(onError, e);
    }
  });
}

function* exportCompanyAnalyticsWatcher() {
  yield takeEvery(companyActions.EXPORT_COMPANY_ANALYTICS, function* ({ payload }) {
    const { companyId, companyName, action } = payload;
    try {
      let actionUrl = action;
      if (actionUrl) {
        actionUrl = '-' + actionUrl;
      }
      const response = yield call(companyService.exportCompanyAnalytics, companyId, actionUrl);
      yield put(companyActions.exportCompanyAnalyticsSuccess());
      yield spawn(downloadBlob, response, companyName + '_' + action);
    } catch (e) {
      yield put(companyActions.exportCompanyAnalyticsFail(e));
      yield spawn(onError, e);
    }
  });
}

function* exportCompaniesWatcher() {
  yield takeEvery(companyActions.EXPORT_COMPANIES, function* () {
    try {
      const response = yield call(companyService.exportCompanies);
      yield put(companyActions.exportCompaniesSuccess());
      yield spawn(downloadBlob, response, 'companies');
    } catch (e) {
      yield put(companyActions.exportCompaniesFail(e));
      yield spawn(onError, e);
    }
  });
}

function* backToCompanyListWatcher() {
  yield takeEvery(
    [companyActions.LOAD_COMPANY_FAIL, companyActions.LOAD_COMPANY_ANALYTICS_FAIL, companyActions.UPDATE_COMPANY_SUCCESS],
    function* () {
      if (history.location.pathname.includes('/companies')) {
        yield call(history.push, '/companies');
      } else if (history.location.pathname.includes('/front/my-companies')) {
        yield call(history.push, '/front/my-companies');
      }
    },
  );
}

export function* companySaga() {
  yield all([
    fork(loadCompanyListWatcher),
    fork(loadMyCompanyListWatcher),
    fork(loadCompanyWatcher),
    fork(loadCompanyAnalyticsWatcher),
    fork(updateCompanyWatcher),
    fork(exportCompanyAnalyticsWatcher),
    fork(backToCompanyListWatcher),
    fork(exportCompaniesWatcher),
  ]);
}
